import { redirectToLogin } from './session.js'
import authHeader from './auth.header.js'

export class ApiError extends Error {
    constructor(status, message, retryAfter = null) {
        super(message)
        this.name = 'ApiError'
        this.status = status
        this.retryAfter = retryAfter
    }
}

export async function apiFetch(url, options = {}) {
    const { skipAuth = false, headers = {}, allowForbiddenResponse = false, ...requestOptions } = options
    const response = await fetch(url, {
        ...requestOptions,
        headers: {
            ...(!skipAuth ? authHeader() : {}),
            ...headers
        }
    })

    if (response.status === 401) {
        redirectToLogin()
        throw new ApiError(401, 'Votre session a expire. Veuillez vous reconnecter.')
    }

    if (response.status === 403 && !allowForbiddenResponse) {
        throw new ApiError(403, 'Vous ne disposez pas des droits suffisants.')
    }

    if (response.status === 422) {
        throw new ApiError(422, 'Les donnees envoyees sont invalides.')
    }

    if (response.status === 429) {
        const retryAfter = response.headers.get('Retry-After')
        const delayMessage = retryAfter ? ` Reessayez dans ${retryAfter} seconde(s).` : ''
        throw new ApiError(429, `Trop de requetes. Veuillez patienter avant de reessayer.${delayMessage}`, retryAfter)
    }

    return response
}
